import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../stylesheets/style.scss";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import { Col, Button, FormGroup, Label, Input } from "reactstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faCalendarAlt,
	faWindowClose,
} from "@fortawesome/free-solid-svg-icons";
import { Resource_APIs } from "./Resource_APIs";
import { Ticket_Variables } from "../variables/Ticket_Variables";
import { UserConsumer } from "../../../UserContext";
import CustomReactSelect from "../../../components/CustomReactSelect";
import { Config, Routes } from "../../../configurations/config";
import moment from "moment";
import { goBackFunction } from "../../../utils";
import FormStatus from "../../../components/FormStatus";
import { AlertPopups } from "../../../components/AlertPopups";

const validation = Yup.object().shape({
	selectItems: Yup.mixed()
		.required("Select any item")
		.typeError("Invalid input"),
	datePicker: Yup.date().required("Select Date").typeError("Invalid input"),

	Description: Yup.string()
		.required("Description is required")
		.max(500, "Max 500 characters allowed"),
	alternateItem: Yup.mixed().when("selectItems", {
		is: (selectItems) => {
			if (selectItems) {
				return selectItems.value === 0;
			}
		},
		then: Yup.string()
			.required("Alternate ticket item is required")
			.max(25, "Max 25 characters allowed")
			.typeError("Invalid value")
			.nullable(),
	}),
});
let token = null,
	userId = null;
class EditTicket extends Component {
	constructor(props) {
		super(props);
		this.state = {
			assigneeDept: "",
			assigneePerson: null,
			selectItems: "",
			selectUrgency: "",
			Description: "",
			attachment: null,
			datePicker: "",
			persons: [],
			departments: [],
			employees: [],
			items: [],
			deptId: "",
			date: new Date().toDateString(),
			ticketDetails: [],
			url: "",
			attChange: false,
			hidden: true,
			alternateItem: "",
			fileErr: false,
		};
	}
	componentDidMount() {
		const headers = {
			Authorization: `Bearer ${token}`,
		};

		axios
			.get(
				`${Resource_APIs.GetTicketDetail_API}${this.props.match.params.ticketId}`,
				{
					headers: headers,
				}
			)
			.then((res) => {
				this.setState({
					ticketDetails: res.data.ticket,
					assigneeDept: {
						value: res.data.ticket.departmentId,
						label: res.data.ticket.department,
					},
					Description: res.data.ticket.details,
					datePicker: new Date(res.data.ticket.expectedTime),
				});
				this.state.ticketDetails.attachedFileName !== "" &&
					this.state.ticketDetails.attachedFileName !== null &&
					this.setState({
						attachment:
							Config.server_url +
							this.state.ticketDetails.attachedFileName,
					});

				this.state.ticketDetails.assignedTo !== null
					? this.setState({
							assigneePerson: {
								value: this.state.ticketDetails.assignedTo,
								label: this.state.ticketDetails.assignee,
							},
					  })
					: this.setState({ assigneePerson: "" });
				this.state.ticketDetails.itemId !== null
					? this.setState({
							selectItems: {
								value: this.state.ticketDetails.itemId,
								label: this.state.ticketDetails.itemName,
							},
					  })
					: this.setState({
							selectItems: {
								value: 0,
								label: "Others",
							},
							hidden: false,
							alternateItem:
								this.state.ticketDetails.alternateTicketItem,
					  });
				axios
					.get(`${Resource_APIs.GetAllDepartments_API}`, {
						headers: headers,
					})
					.then((res) => {
						this.setState({ departments: res.data });
					});
				axios
					.get(
						`${Resource_APIs.GetDepartmentItems_API}${this.state.ticketDetails.departmentId}`,
						{
							headers: headers,
						}
					)
					.then((res) => {
						this.setState({ items: res.data });
						this.state.items.push(Ticket_Variables.others);
					});
				axios
					.get(
						`${Resource_APIs.GetDepartmentEmployees_API}${this.state.ticketDetails.departmentId}`,
						{
							headers: headers,
						}
					)
					.then((res) => {
						this.setState({ employees: res.data });
					});

				this.state.ticketDetails.priority === 0
					? this.setState({
							selectUrgency: { value: 0, label: "High " },
					  })
					: this.state.ticketDetails.priority === 1
					? this.setState({
							selectUrgency: { value: 1, label: "Medium " },
					  })
					: this.setState({
							selectUrgency: { value: 2, label: "Low " },
					  });
			});
	}
	departmentListValues() {
		return this.state.departments
			.map((data) => ({
				label: data.name,
				value: data.id,
			}))
			.sort((a, b) => a.label.localeCompare(b.label));
	}
	openDatepicker = () => this._calendar.setOpen(true);
	employeeListValues() {
		return this.state.employees
			.map((data) => ({
				label: data.employeeName,
				value: data.employeeId,
			}))
			.sort((a, b) => a.label.localeCompare(b.label));
	}
	itemsListValues() {
		return this.state.items
			.map((data) => ({
				label: data.name,
				value: data.ticketItemId,
			}))
			.sort((a, b) => a.label.localeCompare(b.label));
	}
	handleCancel = () => {
		AlertPopups.confirmBox
			.fire({
				text: `${AlertPopups.cancelMsg}`,
			})
			.then((result) => {
				if (result.value) {
					goBackFunction(Routes.MyTickets, this.props.history);
				}
			});
	};
	handleChange = (temp, displayCode, event) => {
		const headers = {
			Authorization: `Bearer ${token}`,
		};
		if (displayCode === 1) {
			this.setState({
				[event.name]: temp,
				assigneePerson: null,
				selectItems: null,
				alternateItem: "",
			});
			axios
				.get(
					`${Resource_APIs.GetDepartmentEmployees_API}${temp.value}`,
					{
						headers: headers,
					}
				)
				.then((res) => {
					this.setState({ employees: res.data });
				});
			axios
				.get(`${Resource_APIs.GetDepartmentItems_API}${temp.value}`, {
					headers: headers,
				})
				.then((res) => {
					this.setState({ items: res.data });

					this.state.items.push(Ticket_Variables.others);
				});
		} else if (
			displayCode === 2 ||
			displayCode === 3 ||
			displayCode === 5
		) {
			this.setState({
				[event.name]: temp,
			});
			if (displayCode === 3)
				this.setState({
					hidden: temp.value != 0,
					alternateItem:
						temp.value === 0 ? this.state.alternateItem : "",
				});
		} else if (displayCode === 4 || displayCode === 7) {
			this.setState({
				[temp.target.name]: temp.target.value.replace(
					new RegExp(`/^([\w\(\),@'\\./!#-&$*+=^~-])/gm`)
				),
			});
		} else if (displayCode === 6) {
			this.setState({
				datePicker: temp,
			});
		} else if (displayCode === 8 || displayCode === 9) {
			if (
				document.getElementById("imageName") &&
				document.getElementById("icon")
			) {
				document.getElementById("imageName").remove();
				document.getElementById("icon").remove();
			}
			if (displayCode === 8) {
				if (temp.target.files[0] !== undefined) {
					this.setState({ fileErr: false });
					if (
						["image/jpeg", "image/jpg", "image/png"].includes(
							temp.target.files[0].type
						)
					) {
						this.setState({
							attachment: temp.target.files[0],
							attChange: true,
						});
					} else {
						this.setState({
							fileErr: true,
						});
					}
				}
			} else {
				this.setState({
					attachment: "",
					attChange: true,
				});
				document.getElementById("attachment").value = null;
			}
		}
	};
	handleSubmit = (values) => {
		if (this.state.fileErr === false) {
			const headers = {
				Authorization: `Bearer ${token}`,
			};
			AlertPopups.confirmBox
				.fire({
					text: `${AlertPopups.saveChangesConfirm}`,
				})
				.then((result) => {
					if (result.value) {
						let data = {
							updateBy: parseInt(userId),
							ticketId: parseInt(
								this.props.match.params.ticketId
							),
							departmentId: values.assigneeDept.value,
							assignTo:
								values.assigneePerson !== null &&
								values.assigneePerson !== ""
									? values.assigneePerson.value
									: null,
							alternateTicketItem:
								values.alternateItem !== ""
									? values.alternateItem
									: null,
							itemId: values.selectItems.value,
							priority: values.selectUrgency.value,
							expectedDate: moment(
								values.datePicker,
								"ddd MMM DD YYYY HH:mm:ss"
							).format("YYYY-MM-DDTHH:mm:00.000"),
							expectedTime: moment(
								values.datePicker,
								"ddd MMM DD YYYY HH:mm:ss"
							).format("YYYY-MM-DDTHH:mm:00.000"),
							details: values.Description,
						};

						if (this.state.attChange) {
							let formImage = new FormData();
							formImage.append(
								"TicketId",
								this.props.match.params.ticketId
							);
							formImage.append(
								"AttachedFileName",
								values.attachment
							);

							axios.put(
								`${Resource_APIs.EditTicketImage_API}`,
								formImage,
								{
									headers: headers,
								}
							);
						}

						axios
							.put(
								`${Resource_APIs.EditTicketByCreator_API}`,
								data,
								{
									headers: headers,
								}
							)
							.then(function (response) {
								if (response.status === 200) {
									AlertPopups.successAlert.fire({
										text: `${AlertPopups.saveChangesMsg}`,
									});
									goBackFunction(
										Routes.MyTicketss,
										this.props.history
									);
								}
							})
							.catch(() => {
								goBackFunction(
									Routes.MyTicketss,
									this.props.history
								);
							});
					}
				});
		}
	};
	render() {
		return (
			<div className="container-fluid pl-3 pr-3">
				<FormStatus
					title="Update Ticket"
					formStatus={this.props.location.state.itemStatus}
					className="create-request d-flex align-items-center"
					onClick={() => {
						this.props.history.push(Routes.MyTickets);
					}}
					navigateBack={true}
				/>
				<UserConsumer>
					{(userDetails) => {
						token = userDetails.token;
						userId = userDetails.id;

						return (
							<Formik
								initialValues={this.state}
								enableReinitialize={true}
								validationSchema={validation}
								validateOnChange={true}
								onSubmit={(values) => this.handleSubmit(values)}
							>
								{({ errors, handleBlur, handleSubmit }) => (
									<form
										onSubmit={handleSubmit}
										className="itemReqForm"
									>
										<FormGroup
											row
											id="row0"
											className="bottom-spacing topBorders"
										>
											<Label sm={12}>
												Edit Ticket #{" "}
												{
													this.props.match.params
														.ticketId
												}
											</Label>
										</FormGroup>
										<FormGroup
											row
											className="bottom-spacing rowStyle1"
										>
											<Label for="assigneeDept" sm={2}>
												Department
												<span className="required">
													*
												</span>
											</Label>
											<Col sm={10}>
												<CustomReactSelect
													options={this.departmentListValues()}
													name="assigneeDept"
													styles={
														Ticket_Variables.react_select_style
													}
													id="assigneeDept"
													bsSize="sm"
													onChange={(value, event) =>
														this.handleChange(
															value,
															1,
															event
														)
													}
													value={
														this.state.assigneeDept
													}
												/>
											</Col>
										</FormGroup>
										<FormGroup
											row
											className="bottom-spacing rowStyle2"
										>
											<Label for="assigneePerson" sm={2}>
												Assign To
											</Label>
											<Col sm={10}>
												<CustomReactSelect
													options={this.employeeListValues()}
													name="assigneePerson"
													id="assigneePerson"
													placeholder=""
													styles={
														Ticket_Variables.react_select_style
													}
													bsSize="sm"
													isClearable
													onChange={(value, event) =>
														this.handleChange(
															value,
															2,
															event
														)
													}
													value={
														this.state
															.assigneePerson
													}
												/>
											</Col>
										</FormGroup>
										<FormGroup
											row
											className="bottom-spacing rowStyle1"
										>
											<Label for="selectItems" sm={2}>
												Select Item
											</Label>
											<Col sm={10}>
												<CustomReactSelect
													options={this.itemsListValues()}
													name="selectItems"
													id="selectItems"
													placeholder=""
													styles={
														Ticket_Variables.react_select_style
													}
													bsSize="sm"
													onChange={(value, event) =>
														this.handleChange(
															value,
															3,
															event
														)
													}
													value={
														this.state.selectItems
													}
													className={
														errors.selectItems
															? "invalid"
															: ""
													}
												/>
											</Col>
										</FormGroup>
										<FormGroup
											row
											id="alternateItemCol"
											className="bottom-spacing rowStyle2"
											hidden={this.state.hidden}
										>
											<Label for="alternateItem" sm={2}>
												Alternate Item
												<span className="required">
													*
												</span>
											</Label>
											<Col sm={10}>
												<Input
													type="text"
													value={
														this.state.alternateItem
													}
													name="alternateItem"
													id="alternateItem"
													bsSize="sm"
													maxLength="25"
													autoComplete="off"
													onChange={(value, event) =>
														this.handleChange(
															value,
															4,
															event
														)
													}
													className={
														errors.alternateItem
															? "invalid"
															: ""
													}
												/>
											</Col>
										</FormGroup>
										<FormGroup
											row
											className={`bottom-spacing  ${
												this.state.hidden
													? "rowStyle2"
													: "rowStyle1"
											}`}
										>
											<Label for="selectUrgency" sm={2}>
												Priority
												<span className="required">
													*
												</span>
											</Label>
											<Col sm={10}>
												<CustomReactSelect
													options={
														Ticket_Variables.UrgencyValues
													}
													name="selectUrgency"
													id="selectItems"
													bsSize="sm"
													styles={
														Ticket_Variables.react_select_style
													}
													onChange={(value, event) =>
														this.handleChange(
															value,
															5,
															event
														)
													}
													value={
														this.state.selectUrgency
													}
												/>
											</Col>
										</FormGroup>
										<FormGroup
											row
											className={`bottom-spacing  ${
												this.state.hidden
													? "rowStyle1"
													: "rowStyle2"
											}`}
											style={{ width: "100%" }}
										>
											<Label for="datePicker" sm={2}>
												Due Date & Time
												<span className="required">
													*
												</span>
											</Label>
											<div
												style={{ fontWeight: "normal" }}
												className="col-sm-10"
											>
												<Col className="datepicker-wrapper pl-1 pr-2">
													<DatePicker
														showYearDropdown
														showMonthDropdown
														dateFormatCalendar=" " //for title
														name="datePicker"
														id="datePicker"
														bsSize="sm"
														selected={
															this.state
																.datePicker
														}
														onChange={(
															value,
															event
														) =>
															this.handleChange(
																value,
																6,
																event
															)
														}
														onChangeRaw={(e) => {
															e.preventDefault();
														}}
														dateFormat="dd/MM/yyyy h:mm a"
														className={`${
															errors.datePicker
																? "px-2 invalid"
																: "px-2"
														}`}
														disabledKeyboardNavigation
														showTimeSelect
														autoComplete="off"
														minDate={new Date()}
														ref={(c) =>
															(this._calendar = c)
														}
													/>
													<FontAwesomeIcon
														icon={faCalendarAlt}
														className="calender-icon"
														color="keppel"
														onClick={
															this.openDatepicker
														}
													/>
												</Col>
											</div>
										</FormGroup>
										<FormGroup
											row
											className={`bottom-spacing  ${
												this.state.hidden
													? "rowStyle2"
													: "rowStyle1"
											}`}
										>
											<Label for="Description" sm={2}>
												Description
												<span className="required">
													*
												</span>
											</Label>
											<Col sm={10}>
												<Input
													type="textarea"
													name="Description"
													id="Description"
													onChange={(value, event) =>
														this.handleChange(
															value,
															7,
															event
														)
													}
													onBlur={handleBlur}
													value={
														this.state.Description
													}
													className={`h-auto ${
														errors.Description
															? "invalid"
															: ""
													}`}
													maxLength="500"
												/>
											</Col>
										</FormGroup>
										<FormGroup
											row
											className={`bottom-spacing lastRow ${
												this.state.hidden
													? "rowStyle1"
													: "rowStyle2"
											}`}
										>
											<Label for="attachment" sm={2}>
												Attachment
											</Label>
											<Col
												sm={9}
												id="attachment-align"
												hidden={
													!this.state.attChange &&
													this.state.ticketDetails
														.attachedFileName
												}
											>
												<Input
													type="file"
													name="attachment"
													id="attachment"
													accept="image/png,image/jpeg,image/jpg "
													onChange={(value, event) =>
														this.handleChange(
															value,
															8,
															event
														)
													}
													className="overflow-hidden"
												/>

												{this.state.fileErr && (
													<div className="input-feedback">
														Only
														".jpeg",".jpg",".png"
														type files allowed
													</div>
												)}
											</Col>

											<Col
												sm={1}
												hidden={
													!this.state.attChange &&
													this.state.ticketDetails
														.attachedFileName
												}
											>
												<FontAwesomeIcon
													icon={faWindowClose}
													className="att-remove-icon1"
													color="keppel"
													onClick={(value, event) =>
														this.handleChange(
															value,
															9,
															event
														)
													}
													hidden={
														!this.state.attachment
													}
												/>
											</Col>
											{this.state.attachment !== null &&
												!this.state.attChange && (
													<>
														<Col sm={2}>
															<div>
																<a
																	id="imageName"
																	href={
																		this
																			.state
																			.attachment
																	}
																	target="_blank"
																	rel="noopener noreferrer"
																	className="link"
																>
																	{this.state.ticketDetails.attachedFileName.slice(
																		20,
																		40
																	)}
																</a>
															</div>
														</Col>
														<Col sm={1}>
															<FontAwesomeIcon
																icon={
																	faWindowClose
																}
																className="att-remove-icon1"
																color="keppel"
																onClick={(
																	value,
																	event
																) =>
																	this.handleChange(
																		value,
																		9,
																		event
																	)
																}
																hidden={
																	!this.state
																		.attachment
																}
															/>
														</Col>
													</>
												)}
										</FormGroup>
										<div className="btns mt-3">
											<Button
												className="submit-btn leftBtn"
												type="Submit"
											>
												UPDATE
											</Button>
										</div>
									</form>
								)}
							</Formik>
						);
					}}
				</UserConsumer>
			</div>
		);
	}
}
export default EditTicket;
